import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Button from '@jetbrains/ring-ui/components/button/button';
import { ExternalLinks } from '@app/common/constants/constants';
import { TitledBlock } from '@app/common/titled-block/titled-block';
import { AiLogo } from '@modules/ai/common/ai-logo/ai-logo';
export function AiDisabledJBA() {
    return (_jsxs(TitledBlock, { title: "AI Enterprise", titleLogo: _jsx(AiLogo, {}), children: ["AI Enterprise is currently disabled for your organization. You can enable the product in your", ' ', _jsx(Button, { text: true, inline: true, href: ExternalLinks.JB_ACCOUNT, children: "JetBrains Account" }), "."] }));
}
